<template>
  <div class="credit">
    <el-dialog
      :title="$t('transportDeliveryOrder.msg.copyReturn')"
      :visible.sync="dialogAdd"
      :close-on-click-modal="false"
      width="1200px"
    >
      <!-- 搜索区域 -->
      <SiruiSearch
        ref="siruiSearch"
        :query="query"
        :colSpan="8"
        :columns="searchColumns"
        @resetBtnClick="resetBtnClick"
        @searchBtnClick="searchBtnClick"
      ></SiruiSearch>
      <!--内容区域-->
      <div class="main-content">
        <sirui-table
          ref="siruiTable"
          :loading="load"
          :data="tableDataReturn"
          :paging="true"
          @currentChange="currentChange"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
          @handleSelectionChange="handleSelectionChange"
          @sortChangeEvent="sortChangeEvent"
          @dblclickEvent="dblclickEvent"
        >
          <vxe-table-column type="radio" width="50" fixed="left"></vxe-table-column>
          <vxe-table-column type="seq" width="60" :title="$t('table.index')"></vxe-table-column>
          <vxe-table-column
            v-for="(item, index) in columnList"
            :key="index"
            :fixed="item.fixed"
            :width="item.width"
            :sortable="item.sortable"
            :field="item.prop"
            :title="item.label"
          >
            <template slot-scope="scope">
              <span v-if="item.prop === 'isReturnMoney'">
                {{ isReturnMoneyData[scope.row[item.prop]] }}
              </span>
              <span v-else>{{ scope.row[item.prop] }}</span>
            </template>
          </vxe-table-column>
        </sirui-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAdd = false">{{ $t('dialog.cancel') }}</el-button>
        <el-button type="primary" @click="gotoAdd()">{{ $t('dialog.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  // import axios from 'axios';
  import { mapState } from 'vuex';
  import API from '@/api/purchaseSalesCenter/purchaseReturn.js';
  import DataBaseAPI from '@/api/dataBase';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  // import status from '@/common/js/status';

  export default {
    components: {
      SiruiTable,
      SiruiSearch,
    },
    name: 'copyPurchaseReturnList',
    data() {
      return {
        dialogAdd: false,
        load: false,
        img: './static/img/tips.png',
        query: {
          returnStatus: 'ZT07',
          returnNo: null,
          returnDepartmentCode: null,
          outboundStorage: null,
          estimatedOutboundTimeStart: null,
          estimatedOutboundTimeEnd: null,
          product: null,
        },
        multipleSelection: [], //存放选中的值
        tableDataReturn: [],
        freightTakerList: [], //运费承担
        requestStatusList: [
          { label: this.$t('purchaseReturn.msg.becameEffective'), value: 'ZT03' },
        ], //申请状态下拉列表
        returnMethodList: [], //退换货方式
        rowData: {}, //被选中的列
        isReturnList: [
          { value: 1, label: this.$t('purchaseReturn.msg.salesReturn') },
          { value: 0, label: this.$t('purchaseReturn.msg.barter') },
        ],
        isReturnData: [
          this.$t('purchaseReturn.msg.barter'),
          this.$t('purchaseReturn.msg.salesReturn'),
        ],
        isReturnMoneyList: [
          { value: 1, label: this.$t('purchaseReturn.msg.yes') },
          { value: 0, label: this.$t('purchaseReturn.msg.no') },
        ],
        isReturnMoneyData: [this.$t('purchaseReturn.msg.no'), this.$t('purchaseReturn.msg.yes')],
      };
    },
    computed: {
      //搜索字段
      searchColumns() {
        return [
          {
            prop: 'returnNo',
            name: this.$t('purchaseReturn.search.returnNo'),
            type: 'input',
            placeholder: this.$t('purchaseReturn.search.returnNoPlaceholder'),
          },
          {
            prop: 'returnDepartmentCode',
            name: this.$t('purchaseReturn.search.departmentCode'),
            placeholder: this.$t('purchaseReturn.search.departmentCodePlaceholder'),
            type: 'treeSelect',
            apiUrl: DataBaseAPI.LIST_COMPANY_API,
            apiData: {
              tenantCode: this.userInfo.userInfo.tenantCode,
              adminFlag: this.userInfo.userInfo.adminFlag,
            },
            clearable: false,
          },
          {
            type: 'searchTableSpec',
            prop: 'outboundStorage',
            getSearchCode: 'storageCode',
            isMultiple: true,
            name: this.$t('purchaseReturn.search.outboundStorageCode'),
            searchType: 'warehouse',
          },
          {
            prop: 'estimatedOutboundTimeStart',
            name: this.$t('purchaseReturn.search.estimatedOutboundTimeStart'),
            type: 'startDaterangePicker',
            placeholder: this.$t('purchaseReturn.search.startDatePlaceholder'),
          },
          {
            prop: 'estimatedOutboundTimeEnd',
            name: this.$t('purchaseReturn.search.estimatedOutboundTimeEnd'),
            type: 'endDaterangePicker',
            placeholder: this.$t('purchaseReturn.search.endDatePlaceholder'),
          },
          {
            type: 'searchTableSpec',
            prop: 'product',
            isMultiple: true,
            getSearchCode: 'productDetailCode',
            name: this.$t('purchaseReturn.search.productName'),
            searchType: 'goodsDetail',
          },
          {
            prop: 'returnStatus',
            name: this.$t('purchaseReturn.search.status'),
            type: 'select',
            placeholder: this.$t('purchaseReturn.search.statusPlaceholder'),
            options: this.requestStatusList,
          },
        ];
      },
      //表格显示字段
      columnList() {
        return [
          {
            prop: 'returnNo',
            label: this.$t('purchaseReturn.search.returnNo'),
            //sortable: true,
          },
          { prop: 'returnStatusName', label: this.$t('purchaseReturn.search.status') },
          // { prop: "estimatedOutboundTime", label: this.$t("purchaseReturn.search.estimatedOutboundTime") },
          { prop: 'outboundStorageName', label: this.$t('purchaseReturn.search.outStorage') },
          { prop: 'returnSalesmanName', label: this.$t('purchaseReturn.search.returnSalesmanNo') },
          {
            prop: 'remainingOutQuantity',
            label: this.$t('transportDeliveryOrder.copySearchTable.remainingQuantityOut'),
          },
          { prop: 'returnOperatorName', label: this.$t('purchaseReturn.search.creatBy') },
          { prop: 'returnDepartmentName', label: this.$t('purchaseReturn.search.department') },
          { prop: 'returnCompanyName', label: this.$t('purchaseReturn.search.company') },
          { prop: 'productName', label: this.$t('purchaseReturn.search.productName') },
          { prop: 'gmtCreate', label: this.$t('purchaseReturn.search.creatDate') },
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
    },
    /**页面必要代码Start */
    mounted() {
      // this.getData()
    },
    methods: {
      openDialog(flag) {
        this.dialogAdd = flag;
        this.$nextTick(() => {
          this.getData();
        });
      },
      //获取字典值
      getDic() {
        const tenantCode = this.userInfo.tenantCode; // 租户编码
        // 合作伙伴类型
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'partner_type', tenantCode })
          .then((res) => {
            if (res.data.code === 0) {
              this.partnerTypeList = res.data.data; // 下拉
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          });
        //运费承担
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'freight_taker', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.freightTakerList = res.data.data;
            }
          });
        //退换货方式
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'return_method', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.returnMethodList = res.data.data;
            }
          });
      },

      //获取数据
      getData() {
        let query = JSON.parse(JSON.stringify(this.query));
        // console.log(query)
        query.productNo =
          query.product && query.product[0]
            ? query.product[0].allProductDetailCode
              ? query.product[0].allProductDetailCode
              : query.product[0].productDetailCode
            : '';
        query.outboundStorageCode =
          query.outboundStorage &&
          query.outboundStorage.length > 0 &&
          query.outboundStorage[0].storageCode
            ? query.outboundStorage[0].storageCode
            : ''; //仓库
        delete query.returnSalesman;
        delete query.returnOperator;
        delete query.partnerList;
        delete query.outboundStorage;
        query.pageSize = this.$refs.siruiTable.page.pageSize;
        query.pageNum = this.$refs.siruiTable.page.pageNum;
        this.load = true;
        this.$axios.post(API.LIST_FOR_TRANSPROT, query).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableDataReturn = res.data.data.list || res.data.data;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //搜索
      searchBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
      //重置
      resetBtnClick() {
        this.$refs.siruiTable.clearCheckboxReserve();
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.getData();
      },
      //每页条数
      handleSizeChange() {
        this.getData();
      },
      //第几页
      handleCurrentChange() {
        this.getData();
      },
      //checkbox选中触发事件
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
      //表格选中事件
      currentChange(row) {
        if (JSON.stringify(this.rowData) == '{}' || this.rowData.id != row.id) {
          this.rowData = row;
        } else if (this.rowData.id == row.id) {
          this.rowData = {};
        }
      },
      //调用接口排序
      sortChangeEvent({ column, property, order }) {
        console.log(column, property, order);
      },
      //打开新增页面
      gotoAdd() {
        if (this.multipleSelection.length === 0) {
          this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
        } else if (this.multipleSelection.length > 1) {
          this.$message({
            showClose: true,
            message: this.$t('xTable.onlyOneSelect'),
            type: 'error',
          });
        } else {
          this.dialogAdd = false;
          let path = {
            path: '/logistics/transportDeliveryOrderAdd',
            name: 'transportDeliveryOrderAdd',
            meta: {
              keepAlive: true,
              title: this.$t('purchaseReturn.msg.logisticsAdded'),
            },
            query: { flag: 2, no: this.multipleSelection[0].returnNo, type: 0 }, //type 0:新增
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
        }
      },
      //双击事件
      dblclickEvent(value) {
        this.dialogAdd = false;
        let path = {
          path: '/purchase/purchaseReturnDetail',
          name: 'purchaseReturnDetail',
          meta: {
            keepAlive: true,
          },
          query: { returnNo: value.row.returnNo, canEdit: '0' },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      /**页面必要代码End */
    },
  };
</script>
